// This file is part of MinIO Console Server
// Copyright (c) 2023 MinIO, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU Affero General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU Affero General Public License for more details.
//
// You should have received a copy of the GNU Affero General Public License
// along with this program.  If not, see <http://www.gnu.org/licenses/>.

import React, { useEffect, useState } from "react";

import { AppState, useAppDispatch } from "../../../store";

import { useLocation, useNavigate } from "react-router-dom";
import { Bucket } from "api/consoleApi";
import { api } from "../../../api";
import * as MegaUI from "@liujianhong285/megaui";
import { useSelector } from "react-redux";

(MegaUI as any)?.install?.();

const MenuWrapper = () => {
  const navigate = useNavigate();
  const { pathname = "" } = useLocation();
  const addBucketLoading = useSelector(
    (state: AppState) => state.addBucket.loading,
  );

  const [records, setRecords] = useState<Bucket[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!addBucketLoading) {
      setLoading(true);
    }
  }, [addBucketLoading]);

  useEffect(() => {
    if (loading) {
      const fetchRecords = () => {
        api.buckets
          .listBuckets()
          .then((res) => {
            if (res.data) {
              setRecords(res.data.buckets || []);
            }
          })
          .finally(() => {
            setLoading(false);
          });
      };
      fetchRecords();
    }
  }, [loading]);

  const filteredRecords = records;

  if (
    ["/browser", "/browser/"].includes(pathname) &&
    filteredRecords.length > 0
  ) {
    navigate(`/browser/${filteredRecords?.[0].name}`);
  }

  return (
    <mg-side name="Megablob">
      <div
        style={{
          marginBottom: 10,
          width: 65,
          overflowY: "auto",
          overflowX: "hidden",
          maxHeight: `calc(100vh - 218px)`,
        }}
      >
        <div
          style={{
            width: 65,
          }}
        >
          <mg-side-menu>
            <mg-side-button
              tip={"Create Bucket"}
              onClick={() => {
                navigate(`/buckets/add-bucket`);
              }}
              {...(pathname === `/buckets/add-bucket` ? { active: true } : {})}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentcolor"
                viewBox="0 0 256 256"
                width={20}
                height={20}
              >
                <defs>
                  <clipPath id="prefix__a">
                    <path d="M0 0h256v256H0z"></path>
                  </clipPath>
                </defs>
                <g clip-path="url(#prefix__a)">
                  <path fill="none" d="M0 0h256v256H0z"></path>
                  <path
                    data-name="Rect\xE1ngulo 858"
                    fill="none"
                    d="M0 0h256v256H0z"
                  ></path>
                  <path
                    data-name="Uni\xF3n 20"
                    d="M102.405 230.399v-76.79h-76.8a25.607 25.607 0 0 1 0-51.214h76.8V25.601a25.6 25.6 0 1 1 51.2 0v76.792h76.8a25.607 25.607 0 0 1 0 51.214h-76.8v76.792a25.6 25.6 0 1 1-51.2 0Z"
                  ></path>
                </g>
              </svg>
            </mg-side-button>
            {filteredRecords.map((record) => (
              <React.Fragment key={record.name}>
                <mg-side-button
                  tip={record.name}
                  onClick={() => {
                    navigate(`/browser/${record.name}`);
                  }}
                  {...(pathname === `/browser/${record.name}`
                    ? { active: true }
                    : {})}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentcolor"
                    viewBox="0 0 16 16"
                    width={20}
                    height={20}
                  >
                    <defs>
                      <clipPath id="clip-path-buckets">
                        <rect
                          id="Rectángulo_928"
                          data-name="Rectángulo 928"
                          width="15.957"
                          height="15.928"
                        ></rect>
                      </clipPath>
                    </defs>
                    <g id="BucketsIcons-Full" transform="translate(0.283)">
                      <g id="BucketsIcon-full" transform="translate(-0.283)">
                        <rect
                          id="Rectángulo_884"
                          data-name="Rectángulo 884"
                          width="15.939"
                          height="15.911"
                          transform="translate(0.061)"
                          fill="none"
                        ></rect>
                        <g
                          id="Grupo_2272"
                          data-name="Grupo 2272"
                          transform="translate(0 0.072)"
                        >
                          <g
                            id="Grupo_2271"
                            data-name="Grupo 2271"
                            clip-path="url(#clip-path-buckets)"
                          >
                            <path
                              id="Trazado_7002"
                              data-name="Trazado 7002"
                              d="M15.619.545A1.341,1.341,0,0,0,14.553,0H1.386A1.34,1.34,0,0,0,.32.545a1.606,1.606,0,0,0-.3,1.242c.325,1.888,1.009,5.869,1.557,9.045v.006c.277,1.616.519,3.023.661,3.84A1.422,1.422,0,0,0,3.6,15.911h8.733A1.423,1.423,0,0,0,13.7,14.679l.659-3.836,0-.023.893-5.2,0-.015.658-3.821a1.6,1.6,0,0,0-.3-1.242M13.187,11.3l-10.426,0-.2-1.189H13.383Zm.89-5.216-12.221,0L1.651,4.9H14.273Z"
                              transform="translate(0.061 -0.072)"
                            ></path>
                          </g>
                        </g>
                      </g>
                      <rect
                        id="Rectángulo_929"
                        data-name="Rectángulo 929"
                        width="15.957"
                        height="15.928"
                        transform="translate(-0.283 0.072)"
                        fill="none"
                      ></rect>
                    </g>
                  </svg>
                </mg-side-button>
              </React.Fragment>
            ))}
          </mg-side-menu>
        </div>
      </div>
    </mg-side>
  );

  // return (
  //   <Menu
  //     isOpen={sidebarOpen}
  //     displayGroupTitles
  //     options={allowedMenuItems}
  //     applicationLogo={{
  //       applicationName: getLogoApplicationVariant(),
  //       subVariant: getLogoVar(),
  //     }}
  //     callPathAction={(path) => {
  //       navigate(path);
  //     }}
  //     signOutAction={() => {
  //       navigate("/logout");
  //     }}
  //     collapseAction={() => {
  //       dispatch(menuOpen(!sidebarOpen));
  //     }}
  //     currentPath={pathname}
  //     mobileModeAuto={false}
  //   />
  // );
};

export default MenuWrapper;
